<template>
  <div class="base-field" :class="styles.parent || ''">
    <label v-if="label" :for="id" class="base-field__label">{{ label }}</label>

    <div class="field-container">
      <slot name="preppend" />
      <div class="input-container" :class="{ required: required, tight: tight }">
        <slot />
      </div>
      <slot name="append" />
    </div>

    <div class="field-errors">
      <slot name="errors" :errorMessages="errorMessages">
        <span v-for="error in errorMessages" :key="error">
          {{ error }}
        </span>
      </slot>
    </div>
  </div>
</template>

<script>
const LAYOUTS = {
  'horizontal-label': {
    parent: 'd-flex align-items-center form-row',
  },
};

export default {
  name: 'BaseField',
  props: {
    label: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    tight: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: String,
      default: 'horizontal-label',
      validator(value) {
        return Object.keys(LAYOUTS).includes(value) || value === '';
      },
    },
  },
  computed: {
    styles() {
      return this.layout ? LAYOUTS[this.layout] : {};
    },
  },
};
</script>

<style lang="scss">
.base-field {
  margin: 0.8rem 0;
  &.form-row {
    min-height: 55px;
    vertical-align: middle;
    justify-content: flex-end;

    label {
      margin: 0;
      display: block;
      width: 20%;
    }

    .field-container {
      display: flex;
      flex: 1;
    }

    .input-container {
      flex: 1;
      margin: 0 0.5rem;
      position: relative;

      &.required::after {
        content: '*';
        color: red;
        position: absolute;
        right: 6px;
        top: 2px;
      }

      input,
      select {
        width: 100%;
        border: 1px solid #ced4da !important;
        background-image: none !important;

        &.invalid {
          border-color: red !important;
        }
      }
    }

    .field-errors {
      flex-basis: 80%;
      padding-left: 0.5rem;
    }
  }
  .field-errors {
    font-size: 12px;
    color: red;
  }
}
</style>
